import Formatter from '../../../services/Formatter';

export function formatarCepFornecedorExibicao(cep: string | undefined): string {
  const d = Formatter.getNumeros(String(cep ?? '')).slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

export function iniciaisEnderecoDetalhadoFornecedor(fornecedor: Fornecedor | null | undefined) {
  return {
    logradouro: (fornecedor?.logradouro ?? '').toString(),
    numero: (fornecedor?.numero ?? '').toString(),
    complemento: (fornecedor?.complemento ?? '').toString(),
    bairro: (fornecedor?.bairro ?? '').toString(),
    cep: formatarCepFornecedorExibicao(fornecedor?.cep),
    inscricao_estadual: (fornecedor?.inscricao_estadual ?? '').toString(),
  };
}

export function payloadEnderecoDetalhadoFornecedor(s: {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cep: string;
  inscricao_estadual: string;
}) {
  return {
    logradouro: s.logradouro,
    numero: s.numero,
    complemento: s.complemento,
    bairro: s.bairro,
    cep: s.cep ? Formatter.getNumeros(s.cep) : null,
    inscricao_estadual: s.inscricao_estadual,
  };
}
